import React from 'react'
import { ChannelSendButton } from '../Channel/ChannelSendButton'
import { ComposerAddNoteButton } from './ComposerAddNoteButton'
import { ComposerModeEnum, useConversationContext } from './Context'
import { useComposerAddNote } from './useComposerAddNote'
import styles from '../Channel/ComposerToolbarEnd.module.scss'

// The send control every Conversation mount without its own keeps: Public reply is the channel's
// plain Send, Internal note swaps it for the warning "Add note" button.
export const ConversationSendButton = () => {
  const { composerMode } = useConversationContext()
  const { onAddNote, savingNote } = useComposerAddNote()

  if (composerMode === ComposerModeEnum.Note) {
    return <ComposerAddNoteButton className={styles.sendButton} onClick={onAddNote} isBusy={savingNote} />
  }

  return <ChannelSendButton />
}
